import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import clsx from 'clsx';
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { usePopper } from 'react-popper';
import { BodyTextXSmall } from '../Typography/Typography';
import * as styles from './Tooltip.module.scss';
const overridePositionStyles = {
    left: {
        left: 6,
        transform: 'unset',
    },
    right: {
        left: 'unset',
        right: 12,
        transform: 'unset',
    },
    center: {},
};
const getPosition = (placement) => {
    if (!placement) {
        return false;
    }
    if (placement.includes('bottom')) {
        return styles.positionBottom;
    }
    if (placement.includes('top')) {
        return styles.positionTop;
    }
    return false;
};
const Container = styled.div({
    backgroundColor: dsColors.gray65,
    padding: 12,
    paddingBottom: 13,
    borderRadius: 4,
    display: 'none',
    '&[data-show]': {
        display: 'block',
    },
});
const Arrow = styled.div({
    visibility: 'hidden',
    border: 0,
    '&, &::before': {
        position: 'absolute',
        width: 0,
        height: 0,
        borderStyle: 'solid',
    },
    '&::before': {
        visibility: 'visible',
        content: '""',
    },
});
const showEvents = ['mouseenter', 'focus'];
const hideEvents = ['mouseleave', 'blur'];
export const Tooltip = ({ tooltip, children, arrowPosition = 'center', }) => {
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles, attributes, update } = usePopper(referenceElement, popperElement, {
        modifiers: [
            { name: 'arrow', options: { element: arrowElement, padding: 12 } },
            {
                name: 'offset',
                options: {
                    offset: [10, 8],
                },
            },
        ],
        placement: 'top-end',
    });
    const show = () => {
        popperElement?.setAttribute('data-show', '');
        update?.();
    };
    const hide = () => {
        popperElement?.removeAttribute('data-show');
    };
    const handleReferenceElementRef = (element) => {
        if (element) {
            setReferenceElement(element);
            showEvents.forEach(event => {
                element.addEventListener(event, show);
            });
            hideEvents.forEach(event => {
                element.addEventListener(event, hide);
            });
        }
    };
    const popperPlacement = attributes?.popper?.['data-popper-placement'];
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: handleReferenceElementRef, children: children }), _jsxs(Container, { ref: setPopperElement, style: styles.popper, ...attributes.popper, children: [_jsx(BodyTextXSmall, { fontColor: "white", children: tooltip }), _jsx(Arrow, { ref: setArrowElement, style: { ...styles.arrow, ...overridePositionStyles[arrowPosition] }, className: clsx(getPosition(popperPlacement)) })] })] }));
};
